const MERCHANT_NAME = 'iMusician'
async function validateMerchant(validationURL: string) {
  try {
    const response = await fetch(
      `${process.env.API_URL}/v3/adyen/apple_pay/session`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ validation_url: validationURL }),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to validate merchant: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error validating merchant:', error);
    return null;
  }
}

export const useApplePay = ({
  amount,
  currencyId,
  handlePayment,
}: {
  handlePayment: (event: ApplePayJS.ApplePayPaymentAuthorizedEvent) => void;
  amount?: string;
  currencyId?: string;
}) => {
  const onClick =
    amount && currencyId
      ? () => {
        // Define ApplePayPaymentRequest
        const applePayRequest: ApplePayJS.ApplePayPaymentRequest = {
          countryCode: 'CH',
          currencyCode: currencyId.toUpperCase(),
          merchantCapabilities: ['supports3DS'],
          supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
          total: {
            label: MERCHANT_NAME,
            type: 'final',
            amount,
          },
        };

        // Create ApplePaySession
        const session = new ApplePaySession(3, applePayRequest);

        handleEventsForApplePay(session);

        session.begin();
      }
      : undefined;

  function handleEventsForApplePay(session: ApplePaySession) {
    session.onvalidatemerchant = async (
      event: ApplePayJS.ApplePayValidateMerchantEvent
    ) => {
      // Call your own server to request a new merchant session.
      const merchantSession = await validateMerchant(event.validationURL);
      if (merchantSession && merchantSession.data) {
        session.completeMerchantValidation(merchantSession.data);
      } else {
        console.error('Error during validating merchant');
      }
    };

    session.onpaymentmethodselected = (
      _event: ApplePayJS.ApplePayPaymentMethodSelectedEvent
    ) => {
      // Define ApplePayPaymentMethodUpdate based on the selected payment method.
      // No updates or errors are needed, pass an empty object.
      const update: ApplePayJS.ApplePayPaymentMethodUpdate = {
        newTotal: {
          label: MERCHANT_NAME,
          type: 'final',
          // @ts-ignore
          amount,
        },
      };
      session.completePaymentMethodSelection(update);
    };

    session.onshippingmethodselected = (
      _event: ApplePayJS.ApplePayShippingMethodSelectedEvent
    ) => {
      // Define ApplePayShippingMethodUpdate based on the selected shipping method.
      // No updates or errors are needed, pass an empty object.
      const update: ApplePayJS.ApplePayShippingMethodUpdate = {
        newTotal: {
          label: MERCHANT_NAME,
          type: 'final',
          // @ts-ignore
          amount,
        },
      };
      session.completeShippingMethodSelection(update);
    };

    session.onshippingcontactselected = (
      _event: ApplePayJS.ApplePayShippingContactSelectedEvent
    ) => {
      // Define ApplePayShippingContactUpdate based on the selected shipping contact.
      const update: ApplePayJS.ApplePayShippingMethodUpdate = {
        newTotal: {
          label: MERCHANT_NAME,
          type: 'final',
          // @ts-ignore
          amount,
        },
      };
      session.completeShippingContactSelection(update);
    };

    session.onpaymentauthorized = async (
      event: ApplePayJS.ApplePayPaymentAuthorizedEvent
    ) => {
      // Define ApplePayPaymentAuthorizationResult
      const paymentData = event.payment;
      console.log(event);
      handlePayment(event);

      if (paymentData.token) {
        // Forward token to your gateway for processing payment and return result to apple pay session
        const result: ApplePayJS.ApplePayPaymentAuthorizationResult = {
          status: ApplePaySession.STATUS_SUCCESS,
        };
        session.completePayment(result);
      } else {
        const result: ApplePayJS.ApplePayPaymentAuthorizationResult = {
          status: ApplePaySession.STATUS_FAILURE,
        };
        session.completePayment(result);
      }
    };

    session.oncancel = (_event: ApplePayJS.Event) => {
      console.log('Session Cancelled.');
    };
  }
  return onClick;
};
